import { FC } from 'react';
import { Tag } from '../../../../../../lib/model/Tag';
import { verify_tag_type } from './verify_tag_type';

interface IProps {
	tags: Tag[];
	periodics?: any[];
}

export const SelectedTagsCount: FC<IProps> = ({ tags, periodics }) => {
	const tags_with_color = verify_tag_type(tags, periodics);
	return (
		<table className='table-layout: auto;'>
			<tr data-row-key='1' className='ant-table-row ant-table-row-level-0 '>
				<td className={`mx-0.5 py-1 px-2 mb-2 rounded text-black`}>
					{tags_with_color.length} itens liberados neste contrato
				</td>
			</tr>
		</table>
	);
};
